import { useQuery } from '@tanstack/react-query'
import { briefApi } from '../api/brief'
import { useSpoke } from './useSpoke'

// Today, for the person signed in. It refetches on a slow beat: a day changes at the pace of mail and
// meetings, not of clicks, and a brief that flickers is a brief nobody trusts.
export function useDailyBrief() {
  const spoke = useSpoke()
  return useQuery({
    queryKey: ['brief-today', spoke],
    queryFn: () => briefApi.today(spoke),
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  })
}
